/* src/app/components/verification/verification.component.scss */
:host {
  display: block;
  min-height: 100vh;
}
.verify-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background:
    radial-gradient(
      circle at 8% 8%,
      rgba(37, 59, 128, 0.07),
      transparent 28%),
    radial-gradient(
      circle at 92% 92%,
      rgba(52, 79, 145, 0.06),
      transparent 28%),
    #F4F6FA;
}
.verify-button.loading {
  cursor: wait;
  opacity: 0.85;
}
.spinner-border {
  width: 17px;
  height: 17px;
  border: 2px solid rgba(255, 255, 255, 0.35);
  border-top-color: #ffffff;
  border-radius: 50%;
  animation: verify-spinner 0.7s linear infinite;
}
@keyframes verify-spinner {
  to {
    transform: rotate(360deg);
  }
}
.verify-shell {
  width: 100%;
  min-height: 100vh;
  display: grid;
  grid-template-columns: 50% 50%;
  overflow: hidden;
  background: #ffffff;
  border: 1px solid rgba(15, 23, 42, 0.07);
  box-shadow: 0 24px 70px rgba(15, 23, 42, 0.1), 0 4px 16px rgba(15, 23, 42, 0.04);
}
.verify-visual {
  position: relative;
  overflow: hidden;
  background: #dfe8fa;
  color: #ffffff;
}
.verify-visual::before {
  content: "";
  position: absolute;
  width: 420px;
  height: 420px;
  top: -180px;
  left: -180px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.07);
}
.verify-visual::after {
  content: "";
  position: absolute;
  width: 360px;
  height: 360px;
  right: -170px;
  bottom: -170px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.06);
}
.visual-content {
  position: relative;
  z-index: 1;
  height: 100%;
  padding: 42px;
  display: flex;
  flex-direction: column;
}
.visual-brand {
  display: flex;
  align-items: center;
}
.visual-brand img {
  width: 225px;
  max-width: 100%;
  height: auto;
  filter: brightness(0) invert(1);
}
.visual-image {
  flex: 1;
  min-height: 320px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 30px 0;
}
.visual-image img {
  display: block;
  width: min(100%, 440px);
  max-height: 440px;
  object-fit: contain;
  filter: drop-shadow(0 18px 28px rgba(0, 0, 0, 0.12));
}
.visual-footer {
  display: flex;
  flex-direction: column;
  gap: 14px;
  padding-top: 20px;
}
.visual-footer span {
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 14px;
  line-height: 1.5;
  font-weight: 400;
  color: #253b80;
}
.visual-footer i {
  width: 30px;
  height: 30px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.9);
  font-size: 14px;
}
.verify-panel {
  overflow-y: auto;
  background: #ffffff;
}
.verify-content {
  width: min(500px, 100%);
  min-height: 100%;
  margin: 0 auto;
  padding: 60px 54px 38px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.mobile-brand {
  margin-bottom: 32px;
}
.mobile-brand img {
  width: 250px;
  height: auto;
}
.verify-header {
  margin-bottom: 28px;
}
.verify-eyebrow {
  display: inline-flex;
  align-items: center;
  margin-bottom: 10px;
  font-family: "Outfit";
  font-size: 13px;
  font-weight: 600;
  line-height: 1.4;
  color: #253B80;
  letter-spacing: 0.02em;
}
.verify-header h2 {
  margin: 0 0 10px;
  font-family: "Outfit";
  font-size: 30px;
  font-weight: 700;
  line-height: 1.25;
  color: #111827;
}
.verify-header p {
  max-width: 450px;
  margin: 0;
  font-family: "Outfit";
  font-size: 15px;
  line-height: 1.6;
  color: #6B7280;
}
.verify-alert {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  margin-bottom: 24px;
  padding: 13px 14px;
  border: 1px solid rgba(220, 38, 38, 0.18);
  border-radius: 10px;
  background: #fef2f2;
}
.alert-icon {
  flex: 0 0 auto;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #dc2626;
}
.alert-icon i {
  font-size: 16px;
}
.alert-message {
  flex: 1;
  padding-top: 2px;
  font-family: "Outfit";
  font-size: 13px;
  line-height: 1.45;
  color: #991b1b;
}
.alert-close {
  flex: 0 0 auto;
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 0;
  border-radius: 6px;
  background: transparent;
  color: #991b1b;
  cursor: pointer;
}
.alert-close:hover {
  background: rgba(220, 38, 38, 0.08);
}
.verify-form {
  display: flex;
  flex-direction: column;
  gap: 22px;
}
.form-field {
  width: 100%;
}
.form-field label {
  display: block;
  margin-bottom: 9px !important;
  font-family: "Outfit";
  font-size: 14px;
  font-weight: 600;
  line-height: 1.4;
  color: #111827;
}
.otp-input {
  width: 100%;
  height: 62px;
  display: block;
  box-sizing: border-box;
  padding: 0 18px;
  border: 1px solid #d1d5db;
  border-radius: 12px;
  outline: none;
  background: #ffffff;
  color: #253B80;
  font-family: "Outfit";
  font-size: 26px;
  font-weight: 700;
  line-height: 1;
  text-align: center;
  letter-spacing: 0.42em;
  transition:
    border-color 0.2s ease,
    box-shadow 0.2s ease,
    background-color 0.2s ease;
}
.otp-input::placeholder {
  color: #cbd5e1;
  opacity: 1;
  letter-spacing: 0.35em;
}
.otp-input:hover {
  border-color: #aeb8c8;
}
.otp-input:focus {
  border-color: #253B80;
  background: #fbfcff;
  box-shadow: 0 0 0 4px rgba(37, 59, 128, 0.1);
}
.otp-hint {
  display: flex;
  align-items: center;
  gap: 7px;
  margin-top: 10px;
  font-family: "Outfit";
  font-size: 13px;
  line-height: 1.45;
  color: #6B7280;
}
.otp-hint i {
  flex: 0 0 auto;
  font-size: 13px;
  color: #253B80;
}
.verify-button {
  width: 100%;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  margin-top: 2px;
  border: 0;
  border-radius: 10px;
  background: #253B80;
  color: #ffffff;
  font-family: "Outfit";
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  box-shadow: 0 6px 14px rgba(37, 59, 128, 0.18);
  transition:
    background-color 0.2s ease,
    transform 0.2s ease,
    box-shadow 0.2s ease,
    opacity 0.2s ease;
}
.verify-button:hover:not(:disabled) {
  background: #1e316d;
  transform: translateY(-1px);
  box-shadow: 0 9px 20px rgba(37, 59, 128, 0.22);
}
.verify-button:active:not(:disabled) {
  transform: translateY(0);
}
.verify-button:disabled {
  opacity: 0.55;
  cursor: not-allowed;
  box-shadow: none;
}
.verify-button i {
  font-size: 14px;
}
.login-section {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  margin-top: 24px;
  font-family: "Outfit";
  font-size: 15px;
  line-height: 1.5;
  color: #6B7280;
}
.login-link {
  font-family: "Outfit";
  font-size: 14px;
  font-weight: 600;
  color: #253B80;
  text-decoration: none;
  cursor: pointer;
  transition: color 0.2s ease;
}
.login-link:hover {
  color: #1e316d;
  text-decoration: underline;
}
.verify-security {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-top: 28px;
  padding-top: 18px;
  border-top: 1px solid #eef2f7;
  font-family: "Outfit";
  font-size: 13px;
  line-height: 1.4;
  color: #9CA3AF;
}
.verify-security i {
  font-size: 13px;
  color: #64748b;
}
@media (max-width: 1024px) {
  .verify-page {
    padding: 24px;
  }
  .verify-shell {
    grid-template-columns: 40% 60%;
  }
  .visual-content {
    padding: 32px;
  }
  .verify-content {
    padding: 50px 42px 36px;
  }
  .verify-header h2 {
    font-size: 28px;
  }
}
@media (max-width: 800px) {
  .verify-page {
    padding: 20px;
  }
  .verify-shell {
    grid-template-columns: 1fr;
    max-width: 620px;
    min-height: auto;
  }
  .verify-visual {
    display: none;
  }
  .verify-content {
    width: 100%;
    min-height: auto;
    padding: 44px 42px 38px;
  }
  .mobile-brand {
    display: block;
    margin-bottom: 32px;
  }
}
@media (max-width: 600px) {
  .verify-page {
    padding: 0;
    align-items: stretch;
  }
  .verify-shell {
    width: 100%;
    min-height: 100vh;
    border: 0;
    border-radius: 0;
    box-shadow: none;
  }
  .verify-content {
    padding: 30px 22px 28px;
  }
  .mobile-brand {
    margin-bottom: 30px;
  }
  .mobile-brand img {
    width: 145px;
  }
  .verify-header {
    margin-bottom: 25px;
  }
  .verify-eyebrow {
    margin-bottom: 8px;
    font-size: 12px;
  }
  .verify-header h2 {
    font-size: 26px;
    line-height: 1.25;
  }
  .verify-header p {
    font-size: 14px;
    line-height: 1.6;
  }
  .form-field label {
    font-size: 13px;
  }
  .otp-input {
    height: 58px;
    font-size: 23px;
    letter-spacing: 0.34em;
  }
  .otp-input::placeholder {
    letter-spacing: 0.28em;
  }
  .otp-hint {
    font-size: 12px;
  }
  .verify-button {
    height: 50px;
    font-size: 14px;
  }
  .login-section {
    margin-top: 20px;
    font-size: 13px;
  }
  .login-link {
    font-size: 13px;
  }
  .verify-security {
    font-size: 12px;
  }
}
@media (max-width: 380px) {
  .verify-content {
    padding: 26px 18px 24px;
  }
  .verify-header h2 {
    font-size: 24px;
  }
  .verify-header p {
    font-size: 13px;
  }
  .otp-input {
    height: 54px;
    font-size: 21px;
    letter-spacing: 0.28em;
  }
  .otp-input::placeholder {
    letter-spacing: 0.22em;
  }
  .verify-button {
    height: 48px;
  }
}
/*# sourceMappingURL=verification.component.css.map */
